import { render, staticRenderFns } from "./WorkSelected.vue?vue&type=template&id=1f5e6fd0&scoped=true"
import script from "./WorkSelected.vue?vue&type=script&lang=js"
export * from "./WorkSelected.vue?vue&type=script&lang=js"
import style0 from "./WorkSelected.vue?vue&type=style&index=0&id=1f5e6fd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e6fd0",
  null
  
)

export default component.exports